
import PropTypes from 'prop-types';
import React, { useContext, useCallback, useRef } from 'react';
import { getCurrentStepId, useWizardService } from '@bingads-webui-react/wizard-core';
import { StepPerfMarker } from './step-perf-marker';
import { STEP_STATE, WizardPerfMarkerContext } from './utils';

export const WizardPerfMarker = ({ wizardName, wizardMarker, children }) => {
  const { state } = useWizardService();
  const wizardPerfMarkerContext = useContext(WizardPerfMarkerContext);
  const currentStepId = getCurrentStepId(state);
  const currentStep = `${wizardName}_${currentStepId}`;
  const perfMarkerRef = useRef(currentStep);

  const checkAndCreateChildMarker = useCallback(() => {
    if (!wizardPerfMarkerContext[currentStep] ||
       (wizardPerfMarkerContext[currentStep] === STEP_STATE.AUTO && currentStep === perfMarkerRef.current)) {
      wizardPerfMarkerContext[currentStep] = STEP_STATE.AUTO;
      return <StepPerfMarker markerName={currentStep} parentPerfMarker={wizardMarker} />;
    }
    perfMarkerRef.current = currentStep;
    return null;
  }, [currentStep, wizardMarker, wizardPerfMarkerContext]);

  const register = useCallback(() => {
    if (wizardPerfMarkerContext[currentStep] !== STEP_STATE.AUTO) {
      wizardPerfMarkerContext[currentStep] = STEP_STATE.MANUAL;
    }
  }, [currentStep, wizardPerfMarkerContext]);

  const unregister = useCallback(() => {
    delete wizardPerfMarkerContext[currentStep];
  }, [currentStep, wizardPerfMarkerContext]);

  return (
    <WizardPerfMarkerContext.Provider value={{ register, unregister }}>
      {checkAndCreateChildMarker()}
      {children}
    </WizardPerfMarkerContext.Provider>
  );
};

WizardPerfMarker.propTypes = {
  wizardName: PropTypes.string.isRequired,
  wizardMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
    done: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};
